import { render } from "./AffiliateBanner.vue?vue&type=template&id=bfdb3c8c"
import script from "./AffiliateBanner.vue?vue&type=script&lang=js"
export * from "./AffiliateBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__